import React from 'react';

export const US_STATE_KEYS = [
  { US_STATE_CODE: 'AL', US_STATE: 'Alabama' },
  { US_STATE_CODE: 'AZ', US_STATE: 'Arizona' },
  { US_STATE_CODE: 'AR', US_STATE: 'Arkansas' },
  { US_STATE_CODE: 'CA', US_STATE: 'California' },
  { US_STATE_CODE: 'CO', US_STATE: 'Colorado' },
  { US_STATE_CODE: 'CT', US_STATE: 'Connecticut' },
  { US_STATE_CODE: 'DC', US_STATE: 'DC' },
  { US_STATE_CODE: 'DE', US_STATE: 'Delaware' },
  { US_STATE_CODE: 'FL', US_STATE: 'Florida' },
  { US_STATE_CODE: 'GA', US_STATE: 'Georgia' },
  { US_STATE_CODE: 'ID', US_STATE: 'Idaho' },
  { US_STATE_CODE: 'IL', US_STATE: 'Illinois' },
  { US_STATE_CODE: 'IN', US_STATE: 'Indiana' },
  { US_STATE_CODE: 'IA', US_STATE: 'Iowa' },
  { US_STATE_CODE: 'KA', US_STATE: 'Kansas' },
  { US_STATE_CODE: 'KY', US_STATE: 'Kentucky' },
  { US_STATE_CODE: 'LA', US_STATE: 'Louisiana' },
  { US_STATE_CODE: 'ME', US_STATE: 'Maine' },
  { US_STATE_CODE: 'MD', US_STATE: 'Maryland' },
  { US_STATE_CODE: 'MA', US_STATE: 'Massachusetts' },
  { US_STATE_CODE: 'MI', US_STATE: 'Michigan' },
  { US_STATE_CODE: 'MN', US_STATE: 'Minnesota' },
  { US_STATE_CODE: 'MS', US_STATE: 'Mississippi' },
  { US_STATE_CODE: 'MO', US_STATE: 'Missouri' },
  { US_STATE_CODE: 'MT', US_STATE: 'Montana' },
  { US_STATE_CODE: 'NE', US_STATE: 'Nebraska' },
  { US_STATE_CODE: 'NV', US_STATE: 'Nevada' },
  { US_STATE_CODE: 'NH', US_STATE: 'New Hampshire' },
  { US_STATE_CODE: 'NJ', US_STATE: 'New Jersey' },
  { US_STATE_CODE: 'NM', US_STATE: 'New Mexico' },
  { US_STATE_CODE: 'NY', US_STATE: 'New York' },
  { US_STATE_CODE: 'NC', US_STATE: 'North Carolina' },
  { US_STATE_CODE: 'ND', US_STATE: 'North Dakota' },
  { US_STATE_CODE: 'OH', US_STATE: 'Ohio' },
  { US_STATE_CODE: 'OK', US_STATE: 'Oklahoma' },
  { US_STATE_CODE: 'OR', US_STATE: 'Oregon' },
  { US_STATE_CODE: 'PA', US_STATE: 'Pennsylvania' },
  { US_STATE_CODE: 'RI', US_STATE: 'Rhode Island' },
  { US_STATE_CODE: 'SC', US_STATE: 'South Carolina' },
  { US_STATE_CODE: 'SD', US_STATE: 'South Dakota' },
  { US_STATE_CODE: 'TN', US_STATE: 'Tennessee' },
  { US_STATE_CODE: 'TX', US_STATE: 'Texas' },
  { US_STATE_CODE: 'UT', US_STATE: 'Utah' },
  { US_STATE_CODE: 'VT', US_STATE: 'Vermont' },
  { US_STATE_CODE: 'VA', US_STATE: 'Virginia' },
  { US_STATE_CODE: 'WA', US_STATE: 'Washington' },
  { US_STATE_CODE: 'WV', US_STATE: 'West Virginia' },
  { US_STATE_CODE: 'WI', US_STATE: 'Wisconsin' },
];

export function StateOptionsList() {
  return US_STATE_KEYS.map((US_STATE_LIST) => {
    return (
      <option key={US_STATE_LIST.US_STATE} value={US_STATE_LIST.US_STATE_CODE}>
        {US_STATE_LIST.US_STATE}
      </option>
    );
  });
}
